import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ChaloButton from "../../../../shared/widgets/chaloButton";
import { AuthenticationService } from "../../../../services/authorization";

const SuccessScreen = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const authService = AuthenticationService.getInstance();
    const parentRoute = authService.getMasterParentRoute();
    
    const redirectUrl = `${parentRoute}/camera`;

    const { message = "Success!", buttonText = "Okay" } = location.state || {};

    const navigateBack = () => {
        navigate(redirectUrl);
    };

    return (
        <div className="camera-success row">
            <div className="camera-success-message">
                <h2>{message}</h2>
            </div>
            <div className="col-md-12 camera-success-footer">
                <ChaloButton buttonText={buttonText} onClick={navigateBack} />
            </div>
        </div>
    );
};

export default SuccessScreen;
